import { Action, ConfigBase, AvailableActions, Trigger, WorkflowStep, WorkflowTrigger, WorkflowStepConfig } from './workflow-types';

export function getConfigItemByKey(action, key) {
  for (const configItem of action.config) {
    if (configItem.key === key) {
      return configItem;
    }
  }
  return null;
}

export function getTriggerConfigItemByKey(trigger, key) {
  for (const configItem of trigger.config) {
    if (configItem.key === key) {
      return configItem;
    }
  }
  return null;
}

export function getDefaultConfigValue(action: ConfigBase) {
  const config: WorkflowStepConfig = {};
  for (const configItem of action.config) {
    config[configItem.key] = configItem.defaultValue;
  }
  return config;
}

export function getAction(availableActions: AvailableActions, step: WorkflowStep): Action {
  if (availableActions && availableActions.actions) {
    for (const action of availableActions.actions) {
      if (
        action.adapterName.toLowerCase() === step.action.adapterName.toLowerCase() &&
        (action.adapterName !== 'apptask' || (action.appId === step.config.appId && action.appCommand === step.config.appCommand))
      ) {
        return action;
      }
    }
  }
  return null;
}

export function getDefaultTriggerValue(trigger) {
  const config = {};
  for (const configItem of trigger) {
    config[configItem.key] = configItem.defaultValue;
  }
  return config;
}

export function getTrigger(availableActions: AvailableActions, triggerStep: WorkflowTrigger): Trigger {
  if (availableActions && availableActions.triggers) {
    for (const trigger of availableActions.triggers) {
      const eventType = trigger.config.find((x) => x.key === 'eventType');
      if (triggerStep.type === trigger.type) {
        if (triggerStep.type === 'GoFormzEvent') {
          if (triggerStep.eventType === eventType.defaultValue) {
            return trigger;
          }
        } else if (triggerStep.type === 'appwebhook' && trigger.appId === triggerStep.appId && trigger.webhookId === triggerStep.entityId) {
          return trigger;
        } else if (!triggerStep.appId || (trigger.appId === triggerStep.appId && trigger.eventType === triggerStep.eventType)) {
          return trigger;
        } else if (triggerStep.type === 'ScheduledEvent' && triggerStep.type === trigger.type) {
          return trigger;
        }
      }
    }
  }
  return null;
}
